"use client";

import { GameProvider } from './context/GameContext';

export default function GameLayout({ children }: { children: React.ReactNode }) {
    return (
        <GameProvider data-component-id="src/app/game/layout.tsx:7:8" data-component-path="src/app/game/layout.tsx" data-component-line="7" data-component-end-line="9" data-component-file="layout.tsx" data-component-name="GameProvider" data-component-content="%7B%22elementName%22%3A%22GameProvider%22%7D">
            {children}
        </GameProvider>
    );
}
